module.exports = __webpack_public_path__ + "static/media/max.64e48585.svg";